'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCentralHeaderMenuEnabled = exports.isGratuityPerceptionEnabled = undefined;

var _getCookie = require('../util/getCookie');

var _getCookie2 = _interopRequireDefault(_getCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isGratuityPerceptionEnabled = exports.isGratuityPerceptionEnabled = function isGratuityPerceptionEnabled() {
  return ((0, _getCookie2.default)('TestAB_Groups') || '').indexOf('olx-percepcao-gratuidade_enabled') !== -1;
};

var isCentralHeaderMenuEnabled = exports.isCentralHeaderMenuEnabled = function isCentralHeaderMenuEnabled() {
  return ((0, _getCookie2.default)('TestAB_Groups') || '').indexOf('olx-central-header_enabled') !== -1;
};